module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Echo_Dot.18ace5de.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Echo_Dot.svg
// module id = 3430
// module chunks = 0